import React from 'react';

import { IconProps } from './icon_definition';

export const AllIcon = (props: IconProps) => {
    const { color, ...rest } = props;

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="8" cy="8" r="4.5" stroke={color ?? '#222'} />
        </svg>
    );
};
